import {
  UserManager,
  WebStorageStateStore,
} from '@soniq/util-auth'

export const userManager = new UserManager({
  authority: import.meta.env.VITE_AUTHORITY,
  client_id: import.meta.env.VITE_CLIENT_ID,
  redirect_uri: `${window.location.origin}${window.location.pathname}`,
  post_logout_redirect_uri: window.location.origin,
  userStore: new WebStorageStateStore({
    store: window.localStorage,
  }),
  monitorSession: false, // this allows cross tab login/logout detection
  automaticSilentRenew: true,
  scope: 'openid profile email offline_access',
})
